import React from 'react';

import style from './Page404.module.css';

const page404 = () => <div className={style.main}>404</div>
    
export default page404;